const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");

const AT = require("../core/vault/ActionTypes");
const LoadableButton = require("../office/LoadableButton");
const CopyTable = require("./data/CopyTable");
const {getPurchaseYearFromClassesEndAt} = require("../../shared/SchoolUtil");

const styles = require("./styles/RosteringReview.css");

const pluralities = {
	numClassesCreated: {
		singular: "class",
		plural: "classes",
	},
	numClassesDeactivated: {
		singular: "class",
		plural: "classes",
	},
	numClassesUpdated: {
		singular: "class",
		plural: "classes",
	},
	numSchoolsCreated: {
		singular: "school",
		plural: "schools",
	},
	numStaffCreated: {
		singular: "member",
		plural: "members",
	},
	numStaffPermissionUpdates: {
		singular: "update",
		plural: "updates",
	},
	numStudentsCreated: {
		singular: "student",
		plural: "students",
	},
	numStudentsDeactivated: {
		singular: "student",
		plural: "students",
	},
	numStudentsTransferred: {
		singular: "student",
		plural: "students",
	},
	numTeacherAssignmentsChanged: {
		singular: "assignment change",
		plural: "assignment changes",
	},
	numTeachersDeactivated: {
		singular: "teacher",
		plural: "teachers",
	},
};

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "RosteringReview",

		propTypes: {
			roster: PT.object.isRequired,
			loadStateToStatus: PT.object.isRequired,
			selectedYear: PT.string.isRequired,
			currentYear: PT.number.isRequired,
			schoolState: PT.object.isRequired,
			changeStep: PT.func.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		/**
		 * Get summary text for each item.
		 *
		 * @param {string} which
		 * @param {number} count
		 * @param {number} [previousYear = null] The year of previously cloned roster (if applicable)
		 * @returns {string}
		 */
		getSummaryText: function(which, count, previousYear = null) {
			const plurality = count === 1 ? "singular" : "plural";
			const refYear = previousYear ? `from ${previousYear} ` : "";
			switch (which) {
				case "numClassesCreated":
					return `${count} ${pluralities[which][plurality]} will be created.`;
				case "numClassesDeactivated":
					return `${count} ${pluralities[which][plurality]} ${refYear}will be deactivated.`;
				case "numClassesUpdated":
					return `${count} ${pluralities[which][plurality]} ${refYear}will be updated.`;
				case "numSchoolsCreated":
					return `${count} ${pluralities[which][plurality]} will be created.`;
				case "numStaffCreated":
					return `${count} staff ${pluralities[which][plurality]} will be created.`;
				case "numStaffPermissionUpdates":
					return `${count} staff permission ${pluralities[which][plurality]} will take place.`;
				case "numStudentsCreated":
					return `${count} ${pluralities[which][plurality]} will be created.`;
				case "numStudentsDeactivated":
					return `${count} ${pluralities[which][plurality]} ${refYear}will be deactivated.`;
				case "numStudentsTransferred":
					return `${count} ${pluralities[which][plurality]} ${refYear}will be transferred.`;
				case "numTeacherAssignmentsChanged":
					return `${count} teacher ${pluralities[which][plurality]} will take place.`;
				case "numTeachersDeactivated":
					return `${count} ${pluralities[which][plurality]} ${refYear}will be deactivated.`;
				default:
					return "";
			}
		},

		renderReview: function() {
			const summaries = [];
			const summaryInfo = _.get(
				this.props.roster,
				["validation", "summary"],
				{}
			);

			// If the current roster was automatically cloned from last year's roster
			// at the end of the last academic year by our cron,
			// then we want to add a special message here.
			// When admins upload their own roster for the current year, we want to let them
			// know that there is no need to be alarmed by the list of changes,
			// since these are just changes in relation to last year's roster.
			const previousYear = (() => {
				const currRosterWasAutoCloned = _.get(
					this.props.schoolState,
					["accounts", "purchase", "currentRosterIsAutoClone"],
					false
				);
				if (currRosterWasAutoCloned) {
					const classesEndAt = _.get(
						this.props.schoolState,
						["accounts", "purchase", "classesEndAt"],
						null
					);
					const currentYear = getPurchaseYearFromClassesEndAt(classesEndAt);
					return currentYear ? currentYear - 1 : null;
				} else {
					return null;
				}
			})();

			// Helper to create a list item for a summary field,
			// so long as the count > 0.
			const createSummaryItem = (count, key) => {
				if (count) {
					const s = this.getSummaryText(key, count, previousYear);
					if (s) {
						summaries.push(
							<li className={styles.summaryItem} key={"summaryItem__" + key}>
								{s}
							</li>
						);
					}
				}
			};

			/**
			 * The priorityOrder array lists which fields to display first,
			 * in order of priority.
			 * For instance, we need to display the number of class deactivations first
			 * for emphasis in case any of these deactivations were unintended.
			 */

			const priorityOrder = [
				"numClassesDeactivated",
				"numTeachersDeactivated",
				"numStudentsDeactivated",
			];

			// First display the fields in priority order
			_.each(priorityOrder, key => {
				const count = summaryInfo[key];
				createSummaryItem(count, key);
			});

			// Then display the rest
			const remainingSummaryInfo = _.omit(summaryInfo, priorityOrder);
			_.each(remainingSummaryInfo, (count, key) => {
				createSummaryItem(count, key);
			});

			return summaries.length ? (
				<div className={styles.summaryList}>{summaries}</div>
			) : null;
		},

		renderProcessingStatus: function(rosterProcessing) {
			const processingStatus = rosterProcessing.load || "none";
			const statusText = CopyTable.getRosteringProcessingStatusCopy(
				processingStatus
			);

			return <div className={styles.statusText}>{statusText}</div>;
		},

		processRoster: function() {
			this.props.dispatch({
				type: AT.ROSTERING_PROCESS_CSVS_REQUEST,
				staffRoster: _.get(this.props.roster, [
					"model",
					"staffRoster",
					"contents",
				]),
				studentRoster: _.get(this.props.roster, [
					"model",
					"studentRoster",
					"contents",
				]),
				year:
					this.props.selectedYear === "currentYear"
						? this.props.currentYear
						: this.props.currentYear + 1,
				purchaseID: _.get(this.props.schoolState, [
					"accounts",
					"purchase",
					"id",
				]),
			});
		},

		goToValidateStep: function() {
			this.props.changeStep("validate");
		},

		renderReuploadButton: function(rosterProcessing) {
			const errors = [];
			_.each(rosterProcessing.rosterErrors, (e, idx) => {
				errors.push(
					<div
						className={styles.processingError}
						key={"processingError__" + idx}
					>
						{e}
					</div>
				);
			});
			return (
				<div className={styles.processingResult}>
					<div className={styles.processingFailure}>{errors}</div>
					<div className={styles.button} onClick={this.goToUploadStep}>
						Re-upload Rosters
					</div>
				</div>
			);
		},

		renderSuccessMessage: function(rosterProcessing) {
			return (
				<div className={styles.processingResult}>
					{CopyTable.getRosteringProcessingSuccessCopy(styles)}
				</div>
			);
		},

		renderContinueButton: function(rosterProcessing) {
			const processingStatus = rosterProcessing.load || "none";
			return (
				<LoadableButton
					buttonText={"Confirm"}
					status={this.props.loadStateToStatus[processingStatus]}
					className={styles.button}
					onClick={this.processRoster}
				/>
			);
		},

		renderButton: function(rosterProcessing) {
			const status = rosterProcessing.load || "none";
			if (status === "none" || status === "pending") {
				return this.renderContinueButton(rosterProcessing);
			} else if (status === "done") {
				if (!rosterProcessing.processed) {
					return this.renderReuploadButton(rosterProcessing);
				} else {
					return this.renderSuccessMessage(rosterProcessing);
				}
			}
		},

		render: function() {
			const rosterProcessing = _.get(this.props.roster, "processing", {});
			const nextYearAlert =
				this.props.selectedYear === "currentYear" ? null : (
					<div className={styles.nextYearAlert}>
						{"These changes apply to the next academic year."}
					</div>
				);
			return (
				<div className={styles.main}>
					{this.renderReview()}
					{nextYearAlert}
					{this.renderProcessingStatus(rosterProcessing)}
					{this.renderButton(rosterProcessing)}
				</div>
			);
		},
	})
);
